/* eslint-disable react/prop-types */
import ContentLoader from "react-content-loader";
import { Card, CardBody, Col, Row } from 'reactstrap';

const TeamUserCardLoader = () => {
  const agencyInfo = JSON.parse(localStorage.getItem("agencyInfo") || "{}");
  const layoutTheme = agencyInfo.data?.layout_theme || "light";
  
  return (
    <Col xl="3" sm="6">
      <Card className="border shadow-none">
        <CardBody className="p-1">
          <div className="d-flex flex-column">
            {/* Top row: Profile + Name with shadow line */}
            <div className="d-flex align-items-center mb-2" style={{ boxShadow: "0 0.3px 0 rgb(96, 125, 139)", paddingBottom: "6px" }}>
              {/* Avatar */}
              <div className="me-3">
                <ContentLoader
                  speed={2}
                  width={35}
                  height={35}
                  viewBox="0 0 35 35"
                  backgroundColor={layoutTheme === "light" ? "#f3f3f3" : "var(--bs-header-bg)"}
                  foregroundColor={layoutTheme === "light" ? "#ecebeb" : "var(--bs-white)"}
                >
                  <circle cx="17.5" cy="17.5" r="17.5" />
                </ContentLoader>
              </div>
              
              {/* User Name */}
              <ContentLoader
                speed={2}
                width={120}
                height={20}
                viewBox="0 0 120 20"
                backgroundColor={layoutTheme === "light" ? "#f3f3f3" : "var(--bs-header-bg)"}
                foregroundColor={layoutTheme === "light" ? "#ecebeb" : "var(--bs-white)"}
              >
                <rect x="0" y="2" rx="4" ry="4" width="110" height="16" />
              </ContentLoader>
            </div>
            
            {/* Email with icon */}
            <div className="d-flex align-items-center mb-1" style={{ padding: "2px" }}>
              <ContentLoader
                speed={2}
                width={180}
                height={16}
                viewBox="0 0 180 16"
                backgroundColor={layoutTheme === "light" ? "#f3f3f3" : "var(--bs-header-bg)"}
                foregroundColor={layoutTheme === "light" ? "#ecebeb" : "var(--bs-white)"}
              >
                <rect x="0" y="2" rx="3" ry="3" width="12" height="12" />
                <rect x="18" y="2" rx="3" ry="3" width="150" height="12" />
              </ContentLoader>
            </div>
            
            {/* Mobile with icon */}
            <div style={{ padding: "2px" }}>
              <ContentLoader
                speed={2}
                width={140}
                height={16}
                viewBox="0 0 140 16"
                backgroundColor={layoutTheme === "light" ? "#f3f3f3" : "var(--bs-header-bg)"}
                foregroundColor={layoutTheme === "light" ? "#ecebeb" : "var(--bs-white)"}
              >
                <rect x="0" y="2" rx="3" ry="3" width="12" height="12" />
                <rect x="18" y="2" rx="3" ry="3" width="110" height="12" />
              </ContentLoader>
            </div>
          </div>
        </CardBody>
        
        {/* Bottom Action Buttons */}
        <div className="btn-group btn-icon" role="group">
          <ContentLoader
            speed={2}
            width={100}
            height={40}
            viewBox="0 0 100 40"
            backgroundColor={layoutTheme === "light" ? "#f3f3f3" : "var(--bs-header-bg)"}
            foregroundColor={layoutTheme === "light" ? "#ecebeb" : "var(--bs-white)"}
          >
            <rect x="5" y="8" rx="4" ry="4" width="25" height="24" />
            <rect x="37" y="8" rx="4" ry="4" width="25" height="24" />
            <rect x="69" y="8" rx="4" ry="4" width="25" height="24" />
          </ContentLoader>
        </div>
      </Card>
    </Col>
  );
};

const CustomTeamUserLoader = ({ count = 12 }) => {
  return (
    <Row>
      {Array.from({ length: count }, (_, index) => (
        <TeamUserCardLoader key={index} />
      ))}
    </Row>
  );
};

export default CustomTeamUserLoader;